import styled from 'styled-components';

export const ImageAndVideoUploadFormStyle = styled.div`
  .amondz-form .ant-form-item-label {
    align-self: flex-start;
  }

  .amondz-form-sub-content {
    margin-top: 3px;
    color: #6200ea;
  }
`;
